// main.js: 需注意要在Vue.use(ElementUI)后使用Vue.component(ElUploadExtend.name, ElUploadExtend)才可以生效

import Vue from 'vue'
import { Upload } from 'element-ui'
export default {
  name: 'ElUpload',
  extends: Upload,
  props: {
    onError: {
      type: Function,
      default: function (res) {
        if (res && res.message) {
          const data = JSON.parse(res.message)
          Vue.prototype.$message.info({ message: data.message || data.msg || '上传文件异常,请检查是否授权' })
        }
      }
    },
    useOss: { // 是否携带文件服务系统token
      type: Boolean,
      default: true
    },
    useToken: { // 是否携带本系统用户token
      type: Boolean,
      default: true
    },
    headers: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ossToken () {
      return this.$store.state.user.ossToken
    },
    token () {
      return this.$store.state.user.token
    }
  },
  created () {
    if (this.useToken) this.$set(this.headers, 'token', this.token)
    if (this.useOss) {
      this.$set(this.headers, 'Authorization', this.ossToken)
    }
  }
}
